"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const react_1 = __importStar(require("react"));
const Threedoc_1 = __importDefault(require("../../assets/icons/Threedoc"));
const react_redux_1 = require("react-redux");
const ModalSubMyPost_1 = __importDefault(require("../modal/ModalSubMyPost"));
const ModalConfirm_1 = __importDefault(require("../modal/ModalConfirm"));
const ModalSubUser_1 = __importDefault(require("../modal/ModalSubUser"));
const ModalShare_1 = __importDefault(require("../modal/ModalShare"));
const ModalReportSuccess_1 = __importDefault(require("../modal/ModalReportSuccess"));
const ModalReportReason_1 = __importDefault(require("../modal/ModalReportReason"));
const ModalReportNoti_1 = __importDefault(require("../modal/ModalReportNoti"));
const mockData_1 = require("../../utils/mockData");
const Basic_1 = __importDefault(require("../../networking/apis/Basic"));
const Home_1 = __importDefault(require("../../networking/apis/Home"));
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const slice_2 = require("../../app-reduxs/articleCreating/slice");
const Article_1 = __importDefault(require("../../networking/apis/Article"));
const constants_1 = require("../../constants");
const helpler_1 = require("../../utils/helpler");
const IconThreeDoc = (props) => {
    const { data, uri, displayTweet, firestorePath = 'tweets', displayBlock = false, disabled = false, } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const buttonMenuRef = (0, react_1.useRef)(null);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [visibleMyPost, setVisibleMyPost] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [visibleConfirm, setVisibleConfirm] = (0, react_1.useState)(false);
    const [visibleNoti, setVisibleNoti] = (0, react_1.useState)(false);
    const [visibleModal, setVisibleModal] = (0, react_1.useState)(false);
    const [checked, setChecked] = (0, react_1.useState)(0);
    const [violation, setViolation] = (0, react_1.useState)(0);
    const [visiblePeport, setVisiblePeport] = (0, react_1.useState)(false);
    const [isAlert, setIsAlert] = (0, react_1.useState)(false);
    const [contentConfirm, setContentConfirm] = (0, react_1.useState)('');
    const [titleConfirm, setTitleConfirm] = (0, react_1.useState)('');
    const [type, setType] = (0, react_1.useState)('');
    const checkIdTweet = () => {
        if (data?.tweetId) {
            return data?.tweetId;
        }
        else if (data?.tweet_id) {
            return data?.tweet_id;
        }
        else if (data?._id) {
            return data?._id;
        }
    };
    const checkNameTweet = () => {
        if (data?.nickname) {
            return data?.nickname;
        }
        else if (data?.user_nickname) {
            return data?.user_nickname;
        }
    };
    const checkCommentOrTweet = () => {
        if (data) {
            if (data?.article_comment_id) {
                return 'deleteArticleComment';
            }
            else if (data?.article_id) {
                return 'deleteArticle';
            }
            else if (checkIdTweet()) {
                let containsRelai = data?.path?.indexOf('replies') !== -1;
                if (containsRelai && data?.path) {
                    return 'deleteComment';
                }
                else {
                    return 'deletePost';
                }
            }
        }
        return '';
    };
    const idRepost = () => {
        if (data?.tweetId) {
            return data?.tweetId;
        }
        else if (data?.tweet_id) {
            return data?.tweet_id;
        }
        else if (data?._id) {
            return data?._id;
        }
        else if (data?.article_comment_id) {
            return data?.article_comment_id;
        }
        else if (data?.article_id) {
            return data?.article_id;
        }
    };
    (0, react_1.useEffect)(() => {
        if (type == 'deletePost') {
            setContentConfirm(`投稿が削除されると他のユーザーにも\n投稿が表示されなくなります。`);
            setTitleConfirm(`投稿を削除しますか？`);
            setVisibleConfirm(true);
        }
        else if (type == 'deleteComment') {
            setContentConfirm(`削除したコメントは元に戻すことはできません。`);
            setTitleConfirm(`コメントを削除しますか？`);
            setVisibleConfirm(true);
        }
        else if (type == 'deleteArticle' && data?.content_type == 1) {
            setContentConfirm(`削除した記事を元に戻すことはできません。`);
            setTitleConfirm(`記事を削除しますか？`);
            setVisibleConfirm(true);
        }
        else if (type == 'deleteArticle' && data?.content_type == 2) {
            setContentConfirm(`削除した自分史を元に戻すことはできません。`);
            setTitleConfirm(`自分史を削除しますか？`);
            setVisibleConfirm(true);
        }
        else if (type == 'onBlock') {
            onBlock();
        }
        else if (type == 'onMute') {
            onMute();
        }
        else if (type == 'deleteArticleComment') {
            setContentConfirm(`コメントを削除するとコメントに寄せられた返信も削除されます。`);
            setTitleConfirm(`コメントを削除しますか？`);
            setVisibleConfirm(true);
        }
    }, [type]);
    const callApiDeleteTweet = async () => {
        await Home_1.default.deletePostApi(checkIdTweet() || data._id)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast(type == 'deleteComment' ? 'コメントを削除しました' : '投稿を削除しました'));
            setVisibleConfirm(false);
            setType('');
            displayTweet(checkIdTweet());
        })
            .catch((_err) => {
        });
    };
    const callApiDeleteArticle = async () => {
        await Article_1.default.deletePostArticle(data?.article_id)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast(data?.content_type == 1 ? '記事を削除しました' : '自分史を削除しました'));
            setVisibleConfirm(false);
            setType('');
            displayTweet(data?.article_id);
        })
            .catch((_err) => {
        });
    };
    const callApiDeleteArticleComment = async () => {
        await Article_1.default.deletePostArticleComment(data?.article_comment_id)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast('コメントを削除しました'));
            setVisibleConfirm(false);
            setType('');
            displayTweet(data?.article_comment_id);
        })
            .catch((_err) => {
        });
    };
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const userId = data?.user_id || data?.userId;
    const onConfirm = () => {
        if (type == 'onMute') {
            onMute();
        }
        else if (type == 'onBlock') {
            onBlock();
        }
        else if (type == 'deletePost' || type == 'deleteComment') {
            callApiDeleteTweet();
        }
        else if (type == 'deleteArticle') {
            callApiDeleteArticle();
        }
        else if (type == 'deleteArticleComment') {
            callApiDeleteArticleComment();
        }
    };
    const OnFollow = async () => {
        await Basic_1.default.followUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${checkNameTweet() || constants_1.DEFAULT_NAME}さんをフォローしました`));
            setVisible(false);
        })
            .catch((_err) => {
        })
            .finally(() => { });
    };
    const OnUnFollow = async () => {
        await Basic_1.default.unfollowUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${checkNameTweet() || constants_1.DEFAULT_NAME}さんをフォロー解除しました`));
            setVisible(false);
        })
            .catch((_err) => {
        })
            .finally(() => { });
    };
    const onBlock = async () => {
        await Basic_1.default.blockUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${checkNameTweet() || constants_1.DEFAULT_NAME}さんをブロックしました`));
            setVisible(false);
            setVisibleConfirm(false);
            setType('');
            if (checkIdTweet()) {
                !displayBlock && displayTweet(checkIdTweet());
            }
        })
            .catch((_err) => {
        })
            .finally(() => { });
    };
    const onUnBlock = async () => {
        await Basic_1.default.unblockUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${checkNameTweet() || constants_1.DEFAULT_NAME}さんをブロック解除しました`));
            setVisible(false);
            setVisibleConfirm(false);
            setType('');
        })
            .catch((_err) => {
        })
            .finally(() => { });
    };
    const onMute = async () => {
        await Basic_1.default.muteUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${checkNameTweet() || constants_1.DEFAULT_NAME}さんをミュートしました`));
            setVisible(false);
            setVisibleConfirm(false);
            setType('');
            if (checkIdTweet()) {
                displayTweet(data?.tweetId);
            }
        })
            .catch((_err) => {
        })
            .finally(() => { });
    };
    const onUnMute = async () => {
        await Basic_1.default.unMuteUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${checkNameTweet() || constants_1.DEFAULT_NAME}さんをミュート解除しました`));
            setVisible(false);
            setVisibleConfirm(false);
            setType('');
        })
            .catch((_err) => {
        })
            .finally(() => { });
    };
    const handlePress = (_) => {
        // const { pageX, pageY } = event.nativeEvent
        // setModalPosition({ x: pageX, y: pageY })
        const position = buttonMenuRef.current?.getBoundingClientRect();
        setModalPosition({ x: position.right, y: position.bottom });
        if (dataUser?.user_id == userId && dataUser) {
            setVisibleMyPost(true);
        }
        else {
            setVisible(true);
        }
    };
    const handleChecked = (itemId) => {
        setChecked(itemId);
    };
    const FunctionEdit = () => {
        if (checkIdTweet() || data?._id) {
            if (checkCommentOrTweet() == 'deleteComment') {
                setVisibleMyPost(false);
                (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT, {
                    data: `${(0, helpler_1.urlPost)(`${firestorePath}/${checkIdTweet()}`)}`,
                    type: 'EDIT',
                });
            }
            else {
                setVisibleMyPost(false);
                (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_POST, {
                    data: `${(0, helpler_1.urlPost)(`${firestorePath}/${checkIdTweet()}`)}`,
                    type: 'EDIT',
                });
            }
        }
        else if (data?.article_id && checkCommentOrTweet() == 'deleteArticle') {
            setVisibleMyPost(false);
            Article_1.default.getArticleDetail(data.article_id)
                .then((response) => {
                const article = response.data.data;
                dispatch((0, slice_2.createArticleAction)({
                    status: article.status,
                    article_id: article.article_id,
                    title: article.title || '',
                    full_text: article.full_text || '',
                    thumbnail_image: article.thumbnail_url || '',
                    content_type: article?.content_type || 1,
                    inherited_from_article_id: article.inherited_from_article_id || '',
                    inherited_from_user_id: article.inherited_from_user_id || undefined,
                    inherited_from_user_id_root: article.inherited_from_user_id || undefined,
                    inherited_from_user_nickname: article.inherited_from_user_nickname || '',
                    inherited_from_user_handle: article.inherited_from_user_handle || '',
                    inherited_from_user_thumbnail: article.inherited_from_user_thumbnail_url || '',
                }));
                if (article.hash_tags.length > 0) {
                    const hashtags = article.hash_tags.map((it) => it.name);
                    dispatch((0, slice_2.addHashtagsAction)(hashtags));
                }
                (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE);
            })
                .catch(() => { });
        }
        else if (checkCommentOrTweet() == 'deleteArticleComment') {
            setVisibleMyPost(false);
            (0, rootNavigation_1.navigate)(Routes_1.default?.REP_COMMENT_ARTICLE, {
                article: data?.idArticle,
                comment: data?.article_comment_id,
                target_comment_id: data?.target_comment_id || '',
                type: 'EDIT',
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.TouchableOpacity, { ref: buttonMenuRef, onPress: handlePress, style: { transform: [{ rotate: '90deg' }] }, disabled: disabled },
            react_1.default.createElement(Threedoc_1.default, null)),
        react_1.default.createElement(ModalSubMyPost_1.default, { visible: visibleMyPost, onClose: () => {
                setVisibleMyPost(false);
            }, modalPosition: modalPosition, deletePost: () => {
                setVisibleMyPost(false), setType(checkCommentOrTweet());
            }, edit: FunctionEdit, openModalShare: () => {
                setVisibleMyPost(false);
                setVisibleModal(true);
            } }),
        react_1.default.createElement(ModalConfirm_1.default, { visible: visibleConfirm, onClose: () => {
                setVisibleConfirm(false);
                setType('');
            }, title: titleConfirm, content: contentConfirm, onConfirm: () => {
                onConfirm();
            } }),
        react_1.default.createElement(ModalSubUser_1.default, { visible: visible, onClose: () => setVisible(false), modalPosition: modalPosition, data: data, openModalNoti: () => {
                setVisible(false);
                setVisibleNoti(true);
            }, openModalShare: () => {
                setVisible(false);
                setVisibleModal(true);
            }, OnFollow: () => {
                setVisible(false), OnFollow();
            }, onBlock: () => {
                setVisible(false), onBlock();
            }, onMute: () => {
                setVisible(false), onMute();
            }, OnUnFollow: () => {
                setVisible(false), OnUnFollow();
            }, OnUnMute: () => {
                onUnMute(), setVisible(false);
            }, OnUnBlock: () => {
                onUnBlock(), setVisible(false);
            } }),
        react_1.default.createElement(ModalReportNoti_1.default, { visible: visibleNoti, data: mockData_1.Notification, Violation: mockData_1.Violation, onClose: () => {
                setVisibleNoti(false), setChecked(0), setViolation(0);
            }, onNext: () => {
                setVisiblePeport(true);
                setVisibleNoti(false);
            }, checkArray: checked, handleChecked: handleChecked, setViolation: (data) => {
                setViolation(data);
            } }),
        react_1.default.createElement(ModalReportReason_1.default, { visible: visiblePeport, onClose: () => {
                setVisiblePeport(false), setChecked(0), setViolation(0);
            }, onNext: () => {
                setChecked(0);
                setViolation(0);
                setVisiblePeport(false);
                setIsAlert(true);
            }, checked: checked, violation: violation, typeRepost: checkCommentOrTweet(), idRepost: idRepost() }),
        react_1.default.createElement(ModalReportSuccess_1.default, { visible: isAlert, onClose: () => {
                setIsAlert(false);
            }, title: "\u3054\u5831\u544A\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059", textFirst: "\u5F53\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u5B89\u5168\u3068\u5FEB\u9069\u6027\u3092\u4FDD\u3064\u305F\u3081\u306B\u3054\u5354\u529B\u3044\u305F\u3060\u304D\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002", textSecond: "\u79C1\u305F\u3061\u306E\u30C1\u30FC\u30E0\u304C\u901A\u5831\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3001\u5FC5\u8981\u306A\u5BFE\u5FDC\u3092\u884C\u3044\u307E\u3059\u3002", textThirs: "\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u306B\u306F\u6570\u65E5\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u3054\u7406\u89E3\u304F\u3060\u3055\u3044\u3002", textFour: "\u901A\u5831\u306B\u95A2\u3057\u3066\u3055\u3089\u306A\u308B\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u304C\u5FC5\u8981\u306A\u5834\u5408\u3001\u307E\u305F\u306F\u72B6\u6CC1\u304C\u5909\u5316\u3057\u305F\u5834\u5408\u306F\u3001\u3044\u3064\u3067\u3082\u30B5\u30DD\u30FC\u30C8\u30C1\u30FC\u30E0\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002", 
            // textFive="【ヘルプセンター】XXXXXXXXXXXXXXXXXXXX.co.jp"
            textFive: "" }),
        react_1.default.createElement(ModalShare_1.default, { visible: visibleModal, onClose: () => setVisibleModal(false), uri: uri })));
};
exports.default = IconThreeDoc;
